// components/Dashboard/SubmissionsTable.js
import React from "react";
import { useNavigate } from "react-router-dom";

const SubmissionsTable = ({ submissions = [], onSort, sortField, sortOrder, onDelete }) => {
  const navigate = useNavigate();

  if (submissions.length === 0) {
    return <p className="text-gray-100">No submissions available.</p>;
  }

  const renderSortIndicator = (field) => {
    if (sortField === field) {
      return sortOrder === "asc" ? "▲" : "▼";
    }
    return "";
  };

  return (
    <table className="table-auto w-full bg-gray-800 rounded-lg shadow-lg overflow-hidden text-gray-100">
      <thead className="bg-gray-700 text-gray-100">
        <tr>
          <th className="px-6 py-3 text-left cursor-pointer" onClick={() => onSort("fullName")}>
            Name {renderSortIndicator("fullName")}
          </th>
          <th className="px-6 py-3 text-left cursor-pointer" onClick={() => onSort("phoneNumber")}>
            Phone Number {renderSortIndicator("phoneNumber")}
          </th>
          <th
            className="px-6 py-3 text-left cursor-pointer"
            onClick={() => onSort("lengthOfSobriety")}
          >
            Length of Sobriety {renderSortIndicator("lengthOfSobriety")}
          </th>
          <th
            className="px-6 py-3 text-left cursor-pointer"
            onClick={() => onSort("desiredMoveInDate")}
          >
            Move-In Date {renderSortIndicator("desiredMoveInDate")}
          </th>
          <th className="px-6 py-3 text-left cursor-pointer" onClick={() => onSort("timestamp")}>
            Submission Date {renderSortIndicator("timestamp")}
          </th>
          <th className="px-6 py-3 text-center">Actions</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-700">
        {submissions.map((submission) => (
          <tr key={submission.submissionId} className="hover:bg-gray-700 transition">
            <td className="px-6 py-3">{submission.fullName}</td>
            <td className="px-6 py-3">{submission.phoneNumber}</td>
            <td className="px-6 py-3">{submission.lengthOfSobriety}</td>
            <td className="px-6 py-3">
              {(() => {
                const date = new Date(submission.desiredMoveInDate);
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const day = date.getDate().toString().padStart(2, "0");
                const year = date.getFullYear();
                return `${month}-${day}-${year}`;
              })()}
            </td>
            <td className="px-6 py-3">{new Date(submission.timestamp).toLocaleString()}</td>
            <td className="px-6 py-3 text-center space-x-2">
              <button
                onClick={() => navigate(`/submissions/${submission.submissionId}`)}
                className="text-blue-400 hover:underline"
              >
                View
              </button>
              <button
                onClick={() => onDelete(submission.submissionId)}
                className="text-red-400 hover:underline"
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SubmissionsTable;
